<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="调拨单号"><el-input v-model="query.code" size="small" clearable style="width:150px" /></el-form-item>
      <el-form-item label="产品编码"><el-input v-model="query.materialCode" size="small" clearable style="width:150px" /></el-form-item>
      <el-form-item label="产品名称"><el-input v-model="query.materialName" size="small" clearable style="width:150px" /></el-form-item>
      <el-form-item label="审核状态">
        <el-select v-model="query.status" size="small" clearable placeholder="全部" style="width:120px">
          <el-option label="未审" value="0" /><el-option label="已审" value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="开始日期"><el-date-picker v-model="query.dateFrom" type="date" size="small" value-format="yyyy-MM-dd" clearable /></el-form-item>
      <el-form-item label="结束日期"><el-date-picker v-model="query.dateTo" type="date" size="small" value-format="yyyy-MM-dd" clearable /></el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('inventory:transfer:list')" type="primary" size="small" @click="search">查询</el-button>
        <el-button size="small" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="rows" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" align="center" />
      <el-table-column prop="code" label="调拨单号" min-width="150" />
      <el-table-column prop="bizDate" label="单据日期" width="120" />
      <el-table-column prop="approveStatus" label="审核状态" width="90" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.approveStatus === '2'" type="success" size="small">已审</el-tag>
          <el-tag v-else size="small">未审</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="lineSort" label="行号" width="70" align="center" />
      <el-table-column prop="materialCode" label="物料编码" min-width="130" />
      <el-table-column prop="materialName" label="物料名称" min-width="150" />
      <el-table-column prop="specs" label="规格型号" min-width="120" />
      <el-table-column prop="quantity" label="数量" width="100" align="right" />
      <el-table-column prop="fromWareHousePath" label="调出库位" min-width="200" show-overflow-tooltip />
      <el-table-column prop="toWareHousePath" label="调入库位" min-width="200" show-overflow-tooltip />
      <el-table-column prop="batchNo" label="批号" min-width="100" />
      <el-table-column v-if="inventoryQtyShowSupplier" prop="supplierName" label="供应商" min-width="120" />
      <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip />
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="v => { pageSize = v; search() }" @current-change="v => { pageIndex = v; load() }" />
  </div>
</template>

<script>
import request from '../../api/request'
import { authMixin } from './inventoryShared'
import inventoryQtyShowSupplierMixin from '../../mixins/inventory-qty-show-supplier'

export default {
  name: 'TransferLineDetail',
  mixins: [authMixin, inventoryQtyShowSupplierMixin],
  data() {
    return {
      query: { code: '', materialCode: '', materialName: '', status: '', dateFrom: '', dateTo: '' },
      rows: [], pageIndex: 1, pageSize: 20, total: 0, loading: false
    }
  },
  created() {
    if (this.loadInventoryQtyShowSupplierPolicy) this.loadInventoryQtyShowSupplierPolicy()
    this.load()
  },
  methods: {
    search() { this.pageIndex = 1; this.load() },
    resetQuery() {
      this.query = { code: '', materialCode: '', materialName: '', status: '', dateFrom: '', dateTo: '' }
      this.search()
    },
    load() {
      this.loading = true
      request.get('/inventory/transfer/lines', {
        params: {
          currentPage: this.pageIndex, pageSize: this.pageSize,
          code: this.query.code, materialCode: this.query.materialCode, materialName: this.query.materialName,
          status: this.query.status, dateFrom: this.query.dateFrom, dateTo: this.query.dateTo
        }
      }).then(res => {
        const body = res.data || {}
        this.rows = body.list || []
        this.total = body.totalCount || 0
      }).catch(() => { this.rows = []; this.total = 0 })
        .finally(() => { this.loading = false })
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
</style>
